{
  "version": 1,
  "asset_id": "4ebd8929-d61a-49d6-9759-b572fe04ade8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4ebd8929-d61a-49d6-9759-b572fe04ade8/mark-192.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4ebd8929-d61a-49d6-9759-b572fe04ade8/mark-192.webp",
  "original_filename": "mark-192.webp",
  "size": 10796,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:18:18Z"
}
